/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Typography, Tooltip, Table, Spin } from 'antd';
import get from 'lodash/get';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Button as CrceButton } from '@crc-evans/ui-components';
import {
  ArrowLeft,
  ClipboardList,
  Download,
  FileCheck,
  FileText,
  FlaskConical,
  FolderOpen,
  Pencil,
  Plus,
  Trash2,
  X,
} from 'lucide-react';
import AddNewPQTPipeline from './AddNewPQTPipeline';
import PQTTestPage from './PQTTestPage';
import { deleteSowDetails, fetchSowDetails } from '../../redux/PQTsowDetails/actions';
import PQTResultsPage from './PQTResultsPage';
import '../ShippingManagement/ShipmentDashBoardPage.css';
import { getProjectTableLoadingConfig } from '../ProjectTableLoader';
import './PQTDetailsPage.css';

const { Title } = Typography;

const PQTDetailsPage = (props) => {
  const {
    selectedProject,
    sowDetails,
    onFetchSowDetails,
    stationList,
    testTypesList,
    setStationList,
    isSowLoading,
    onDeleteSowDetails,
    userAccessList,
    projectTeamMembersAccessList,
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  /** When true, pipeline modal is read-only (opened from PQT Results “View details”). */
  const [pipelineModalReadOnly, setPipelineModalReadOnly] = useState(false);
  const [editValue, setEditValue] = useState(false);
  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const [selectedViewRow, setSelectedViewRow] = useState('');
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10);
  const [listCount, setListCount] = useState(1);
  const [selectedSOW, setSelectedSOW] = useState(null);
  const [showPQTTestPage, setShowPQTTestPage] = useState(false);
  const [showPQTResultPage, setShowPQTResultPage] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isFileModalVisible, setIsFileModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [loadingBtn, setLoadingBtn] = useState(false);
  useEffect(() => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      onFetchSowDetails(projId);
    }
  }, [selectedProject]);

  //ITP write access control for normal user
  const isButtonDisabled = () => {
    if (userAccessList.includes('admin') || userAccessList.includes('super-admin')) return false;
    else if (projectTeamMembersAccessList[0]?.isGuestUser) {
      return true;
    } else if (
      projectTeamMembersAccessList[0]?.isNormalUser &&
      !projectTeamMembersAccessList[0]?.tabPermissions?.ITP?.write
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isWriteAccess = isButtonDisabled();

  const [pipelineList, setPipelineList] = useState([
    // {
    //     ID: '1',
    //     Pipeline_Section: 'Mainline-1',
    //     Application_Procedure: "CRCE - Application Procedure Specification - Gas Lift Flowline –Offshore Tie-ins - LE / GTS - PPHSS (CRCE-8915-TE-PR-00002)",
    //     Record_Document: 'CRCE - PQT Report - Gas Lift Flowline – Offshore Tie-ins - LE / GTS - PP HSS(CRC-8915-TE-RP-00002)',
    //     Specification: 'GIS 06-404'
    // }
  ]);
  useEffect(() => {
    setPipelineList(sowDetails);
  }, [sowDetails]);

  const onUpdateClick = (data) => {
    if (data) {
      setSelectedData(data);
      setEditValue(true);
      setPipelineModalReadOnly(false);
      setIsModalVisible(true);
    }
  };

  const onUpdateFileClick = (data) => {
    if (data) {
      setSelectedData(data);

      setIsFileModalVisible(true);
    }
  };

  const onShowTesPgaeClick = async (record) => {
    setSelectedSOW(record);
    setShowPQTTestPage(true);
  };
  const onShowResultPageClick = async (record) => {
    setSelectedSOW(record);
    setShowPQTResultPage(true);
  };
  const UpdatePage = (value) => {
    setShowPQTTestPage(value);
  };

  const SubmittedNewPipeline = () => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      onFetchSowDetails(projId);
    }
  };

  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };

  const handleOk = async () => {
    await onDeleteSowDetails({ data: selectedData });
    setLoadingBtn(true);
    setTimeout(() => {
      setLoadingBtn(false);
      setIsDeleteModalVisible(false);
      setSelectedData('');
    }, 1000);
  };

  const handleCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData('');
  };

  const onClickFileView = async (record) => {
    if (record !== '') {
      setSelectedViewRow(record);
      setShowPDFViewer(true);
    }
  };

  const columns = [
    {
      title: 'Pipeline Section',
      dataIndex: 'pipelineSection',
      key: 'pipelineSection',
      align: 'center',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>{text}</div>
      ),
    },

    {
      title: 'Application Procedure',
      dataIndex: 'applicationProcedure',
      key: 'applicationProcedure',
      align: 'left',
      width: '18%',
    },
    {
      title: 'Record Document',
      dataIndex: 'recordDocument',
      key: 'recordDocument',
      align: 'Center',
    },

    {
      title: 'Specification',
      dataIndex: 'specification',
      key: 'specification',
      align: 'Center',
    },

    {
      title: 'Action',
      dataIndex: 'edit_delete',
      key: 'edit_delete',
      align: 'center',
      render: (text, record) => {
        return (
          <div className="pqt-row-actions">
            <Tooltip title="Update">
              <button
                type="button"
                className="pqt-action-btn"
                aria-label="Update"
                onClick={() => onUpdateClick(record)}
              >
                <Pencil size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>

            <Tooltip title="Test">
              <button
                type="button"
                className="pqt-action-btn"
                aria-label="Test"
                onClick={() => onShowTesPgaeClick(record)}
              >
                <FlaskConical size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>

            <Tooltip title="Results">
              <button
                type="button"
                className="pqt-action-btn"
                aria-label="Results"
                onClick={() => onShowResultPageClick(record)}
              >
                <FileCheck size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>

            <Tooltip title="Delete">
              <button
                type="button"
                className="pqt-action-btn pqt-action-btn--danger"
                aria-label="Delete"
                onClick={() => showDeleteModal(record)}
              >
                <Trash2 size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>

            <Tooltip title="Files">
              <button
                type="button"
                className="pqt-action-btn"
                aria-label="Files"
                onClick={() => onUpdateFileClick(record)}
              >
                <FolderOpen size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const columnsFile = [
    {
      title: 'File Name',
      dataIndex: 'fileName',
      key: 'fileName',
      align: 'left',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'left', height: '100%' }}>{text}</div>
      ),
    },

    {
      title: 'Action',
      dataIndex: 'edit_delete',
      key: 'edit_delete',
      align: 'center',
      render: (text, record) => {
        return (
          <div className="pqt-row-actions">
            <Tooltip title="View PDF">
              <button
                type="button"
                className="pqt-file-link-btn"
                aria-label="View PDF"
                onClick={() => onClickFileView(record)}
              >
                <FileText size={18} strokeWidth={1.75} aria-hidden />
              </button>
            </Tooltip>
            <Tooltip title="Download">
              <a
                href={record.s3Url}
                className="pqt-file-link-btn"
                style={{ marginLeft: '10px' }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download file"
              >
                <Download size={18} strokeWidth={1.75} aria-hidden />
              </a>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const pqtFillViewportHeight =
    showPDFViewer || (!showPQTTestPage && !showPQTResultPage);

  return (
    <div
      className={`pqt-details-root d-flex flex-column ${pqtFillViewportHeight ? 'h-100' : 'pqt-details-root--test-flow'}`}
    >
      {showPDFViewer ? (
        <div className="flex-auto modern-pqt-details-page">
          <div className="pqt-pdf-toolbar">
            <CrceButton
              label="Back"
              variant="tertiary"
              size="small"
              icon={ArrowLeft}
              onClick={() => {
                setShowPDFViewer(false);
              }}
            />
            <Title className="pqt-pdf-viewer-title mb-0" level={4}>
              Viewer
            </Title>
          </div>
          <div className="PQT-pdf-container" style={{ backgroundColor: 'transparent' }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
              <Viewer fileUrl={selectedViewRow.s3Url} plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          </div>
        </div>
      ) : (
        <div className="pqt-details-flex-stack">
          <div className="pqt-details-flex-fill">
            {!showPQTTestPage && !showPQTResultPage && (
              <div>
                <div className="d-flex flex-column h-100 modern-pqt-details-page">
                  <div className="pqt-sow-header">
                    <div className="pqt-sow-header-left">
                      <div className="pqt-sow-header-icon">
                        <ClipboardList size={24} color="#2563eb" strokeWidth={1.75} aria-hidden />
                      </div>
                      <div>
                        <h1 className="pqt-sow-title">Statement of Work</h1>
                      </div>
                    </div>
                    <div className="pqt-sow-header-actions">
                      <CrceButton
                        label="Create New"
                        variant="primary"
                        size="small"
                        icon={Plus}
                        onClick={() => {
                          setSelectedData('');
                          setEditValue(false);
                          setPipelineModalReadOnly(false);
                          setIsModalVisible(true);
                        }}
                      />
                    </div>
                  </div>

                  <div className="pqt-sow-table-shell">
                    <Table
                      columns={columns}
                      className="h-100 pipeline-table equipPaginationTable pqt-sow-ant-table"
                      scroll={{ y: 'calc(100vh - 320px)' }}
                      rowKey={'ID'}
                      pagination={
                        listCount > 10
                          ? {
                              position: ['bottomRight'],
                              showSizeChanger: true,
                              className: 'heat-profile-pagination',
                              total: listCount,
                              defaultPageSize: 10,
                              defaultCurrent: 1,
                              current: currentPageNumber,
                              pageSize: currentPagesize,
                              onChange: async (pageNumber, pageSize, sorter) => {
                                setCurrentPageNumber(pageNumber);
                                setCurrentPagesize(pageSize);

                                var obj = {
                                  pageSize: pageSize,
                                  pageNumber: pageNumber,
                                };

                                // await onRecordList(obj)
                              },
                            }
                          : false
                      }
                      dataSource={[...pipelineList]}
                      loading={getProjectTableLoadingConfig(isSowLoading)}
                    />
                  </div>
                </div>
              </div>
            )}
            {showPQTTestPage && !showPQTResultPage && (
              <div>
                <PQTTestPage
                  stationList={stationList}
                  testTypesList={testTypesList}
                  setStationList={setStationList}
                  selectedProject={selectedProject}
                  showPQTTestPage={showPQTTestPage}
                  setShowPQTTestPage={setShowPQTTestPage}
                  UpdatePage={UpdatePage}
                  selectedSOW={selectedSOW}
                  sowList={pipelineList}
                />
              </div>
            )}

            {showPQTResultPage && !showPQTTestPage && (
              <div className="pqt-details-subpage-host">
                <PQTResultsPage
                  selectedProject={selectedProject}
                  showPQTResultPage={showPQTResultPage}
                  setShowPQTResultPage={setShowPQTResultPage}
                  selectedSOW={selectedSOW}
                  pipelineList={pipelineList}
                />
              </div>
            )}
            {isModalVisible && selectedProject?.id && (
              <AddNewPQTPipeline
                className="details-modal"
                setIsModalVisible={setIsModalVisible}
                isModalVisible={isModalVisible}
                projectId={selectedProject.id}
                editValue={editValue}
                setEditValue={setEditValue}
                SubmittedNewPipeline={SubmittedNewPipeline}
                selectedData={selectedData}
                readOnly={pipelineModalReadOnly}
                setReadOnly={setPipelineModalReadOnly}
                allowPipelineEdit={!isWriteAccess}
              />
            )}
            {isDeleteModalVisible && (
              <div
                className="mc-dpr-modal-backdrop"
                role="presentation"
                onClick={() => !loadingBtn && handleCancel()}
              >
                <div
                  className="mc-dpr-modal mc-dpr-modal--narrow mc-dpr-modal--delete"
                  role="dialog"
                  aria-labelledby="pqt-delete-sow-title"
                  aria-describedby="pqt-delete-sow-desc"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="mc-dpr-modal-head">
                    <h3 id="pqt-delete-sow-title" className="mc-dpr-modal-title">
                      Delete Pipeline Section
                    </h3>
                    <button
                      type="button"
                      className="mc-dpr-modal-close"
                      aria-label="Close"
                      disabled={loadingBtn}
                      onClick={handleCancel}
                    >
                      <X size={20} />
                    </button>
                  </div>
                  <div className="mc-dpr-modal-body">
                    <div id="pqt-delete-sow-desc" className="mc-dpr-modal-delete-body">
                      <p className="mc-dpr-modal-delete-lead">
                        Deleting statement of work will delete all the corresponding Stations and
                        related information.
                      </p>
                      <p className="mc-dpr-modal-delete-lead">
                        Are you sure you want to delete{' '}
                        <span className="mc-dpr-modal-delete-target">
                          {selectedData && selectedData.pipelineSection}
                        </span>{' '}
                        statement of work?
                      </p>
                    </div>
                  </div>
                  <div className="mc-dpr-modal-foot">
                    <CrceButton
                      label="Cancel"
                      variant="tertiary"
                      size="medium"
                      onClick={handleCancel}
                      disabled={loadingBtn}
                    />
                    <span className="mc-delete-confirm-wrap">
                      <CrceButton
                        label={loadingBtn ? 'Deleting…' : 'Delete'}
                        variant="primary"
                        size="medium"
                        onClick={handleOk}
                        disabled={loadingBtn}
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}
            {isFileModalVisible && (
              <div
                className="mc-dpr-modal-backdrop"
                role="presentation"
                onClick={() => setIsFileModalVisible(false)}
              >
                <div
                  className="mc-dpr-modal mc-dpr-modal--wide"
                  role="dialog"
                  aria-labelledby="pqt-files-modal-title"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="mc-dpr-modal-head">
                    <h3 id="pqt-files-modal-title" className="mc-dpr-modal-title">
                      Uploaded Files
                    </h3>
                    <button
                      type="button"
                      className="mc-dpr-modal-close"
                      aria-label="Close"
                      onClick={() => {
                        setIsFileModalVisible(false);
                      }}
                    >
                      <X size={20} />
                    </button>
                  </div>
                  <div className="mc-dpr-modal-body">
                    <Table
                      columns={columnsFile}
                      dataSource={selectedData.documents || []}
                      pagination={false}
                      className="h-100 pipeline-table equipPaginationTable pqt-files-modal-table"
                    />
                  </div>
                  <div className="mc-dpr-modal-foot">
                    <CrceButton
                      label="Cancel"
                      variant="tertiary"
                      size="medium"
                      onClick={() => {
                        setIsFileModalVisible(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ sowPQTReducer, equip }) => {
  const sowDetails = get(sowPQTReducer, 'sowData', []);
  const isSowLoading = get(sowPQTReducer, 'isSowLoading', []);

  const projectTeamMembersAccessList = get(equip, 'projectTeamMembersAccessList', []);
  return {
    sowDetails,
    projectTeamMembersAccessList,
    isSowLoading,
  };
};

const mapDispatchToProps = {
  onFetchSowDetails: fetchSowDetails,
  onDeleteSowDetails: deleteSowDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(PQTDetailsPage);
